import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { StoryPreview } from '@/components/StoryPreview';
import type { GeneratedStory } from 'schemas';
import { generatedStoryPreviewModalMessages } from './generatedStoryPreviewModal.messages';

interface GeneratedStoryPreviewModalProps {
  generatedStory: GeneratedStory | null;
  isOpen: boolean;
  onClose: () => void;
}

export function GeneratedStoryPreviewModal({
  generatedStory,
  isOpen,
  onClose,
}: GeneratedStoryPreviewModalProps) {
  if (!generatedStory || !generatedStory.spreads) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="h-[90vh] overflow-y-auto p-4 sm:max-w-[90vw] lg:max-w-[50vw]">
        <DialogTitle className="sr-only">
          {generatedStoryPreviewModalMessages.dialogTitle.replace(
            '{title}',
            generatedStory.title
          )}
        </DialogTitle>
        <DialogDescription className="sr-only">
          {generatedStoryPreviewModalMessages.dialogDescription
            .replace('{title}', generatedStory.title)
            .replace('{spreadCount}', String(generatedStory.spreads.length))}
        </DialogDescription>
        <StoryPreview
          title={generatedStory.title}
          spreads={generatedStory.spreads}
        />
      </DialogContent>
    </Dialog>
  );
}
